import getMixingPlant from "./getMixingPlant";
import createMixingPlant from "./createMixingPlant";
import updateMixingPlant from "./updateMixingPlant";
import deleteMixingPlant from "./deleteMixingPlant";

export { getMixingPlant, createMixingPlant, updateMixingPlant, deleteMixingPlant };

export default { getMixingPlant, createMixingPlant, updateMixingPlant, deleteMixingPlant };
